const districtList = [
    'Central & Western',
    'Eastern',
    'Southern',
    'Wan Chai',
    'Kowloon City',
    'Kwun Tong',
    'Sham Shui Po',
    'Wong Tai Sin',
    'Yau Tsim Mong',
    'Kwai Tsing',
    'North',
    'Sai Kung',
    'Sha Tin',
    'Tai Po',
    'Tsuen Wan',
    'Tuen Mun',
    'Yuen Long',
    'Islands'
];

export { districtList };
